module.exports = __webpack_public_path__ + "img/29.e9fde285.jpg";